import React, {Component} from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free-brands';
import '@fortawesome/fontawesome-free-solid';

class Footer extends Component {
    render() {
        return (
            <div>
                <div uk-grid="true">
                    <div className="uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-1@s  uk-text-center">
                        <h4>Connect</h4>
                        <a href="https://github.com/sajid-dev" target="_blank"><FontAwesomeIcon icon={["fab", "github-square"]} className="fa-2x"/></a><span>&nbsp;&nbsp;&nbsp;</span>
                        <a href="https://www.linkedin.com/in/sajid-md-560299149" target="_blank"><FontAwesomeIcon icon={["fab", "linkedin"]} className="fa-2x"/></a><span>&nbsp;&nbsp;&nbsp;</span>
                        <a href="#"><FontAwesomeIcon icon={["fab", "twitter-square"]} className="fa-2x"/></a><span>&nbsp;&nbsp;&nbsp;</span>
                        <a href="#"><FontAwesomeIcon icon={["fab", "google-plus-square"]} className="fa-2x"/></a>
                    </div>
                    <div className="uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-1@s uk-text-center">
                        <h4>Address</h4>
                        <address>
                            Bentonville, Arkansas 72712
                        </address>
                    </div>
                    <div className="uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-1@s uk-text-center">
                        <h4>Contact</h4>
                        <p>
                            <FontAwesomeIcon icon="at"/> Email: sajid.***@****.com <br/>
                            <FontAwesomeIcon icon="mobile"/> Phone: (669) ***-****
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer;



// WEBPACK FOOTER //
// src/components/Footer.js